import { Link } from 'react-router-dom';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';
import { featuredChefs } from '../../../mocks/chefs';

export default function FeaturedChefs() {
  const topChefs = featuredChefs.slice(0, 3);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Featured <span className="text-emerald-600">Private Chefs</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet some of our most celebrated chefs who bring exceptional culinary experiences 
            directly to your table across South Africa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {topChefs.map((chef) => (
            <Card key={chef.id} hover className="overflow-hidden">
              <div className="relative">
                <img 
                  src={chef.image} 
                  alt={chef.name}
                  className="w-full h-64 object-cover object-top"
                />
                <div className="absolute top-4 right-4">
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                    chef.available 
                      ? 'bg-emerald-100 text-emerald-800' 
                      : 'bg-red-100 text-red-800'
                  }`}>
                    {chef.available ? 'Available' : 'Booked'}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{chef.name}</h3>
                <p className="text-emerald-600 font-medium mb-2">{chef.specialty}</p>
                <p className="text-gray-600 mb-4 flex items-center">
                  <div className="w-4 h-4 flex items-center justify-center mr-2">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  {chef.location}
                </p>
                
                <div className="flex items-center mb-4">
                  <div className="flex items-center mr-4">
                    <div className="w-4 h-4 flex items-center justify-center mr-1">
                      <i className="ri-star-fill text-yellow-400 text-sm"></i>
                    </div>
                    <span className="font-medium">{chef.rating}</span>
                    <span className="text-gray-500 ml-1">({chef.reviews})</span>
                  </div>
                  <span className="text-gray-600">{chef.experience}</span>
                </div>
                
                <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                  {chef.id === 'gordon-ramsay' ? (
                    <>
                      Award-winning chef specializing in contemporary South African flavors with international techniques. <a href="https://gordonscreations.co.za/" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:text-emerald-700 underline">Private Chef Johannesburg</a>.
                    </>
                  ) : (
                    chef.description
                  )}
                </p>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  {chef.cuisines.slice(0, 2).map((cuisine) => (
                    <span 
                      key={cuisine}
                      className="px-2 py-1 bg-gray-100 text-gray-700 rounded-md text-xs"
                    >
                      {cuisine}
                    </span>
                  ))}
                </div>
                
                <div className="flex space-x-3">
                  <Link to="/profile/private-chef-johannesburg-gordon" className="flex-1">
                    <Button className="w-full whitespace-nowrap">
                      View Profile
                    </Button>
                  </Link>
                  <Button variant="outline" size="sm" className="whitespace-nowrap">
                    <i className="ri-message-line"></i>
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button size="lg">
            View All Chefs
            <div className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Button>
        </div>
      </div>
    </section>
  );
}
